/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { INosOriginOfInterestPickerViewProps } from './nos-origin-of-interest-picker';

const CustomerSourcesNode: React.FC<any> = ({ customerSources }) => {
    return <Node className=''>{customerSources}</Node>;
};

export default (props: INosOriginOfInterestPickerViewProps) => {
    const { CustomerSourcePicker, customerSources } = props;

    return (
        <Module {...CustomerSourcePicker}>
            <CustomerSourcesNode customerSources={customerSources} />
        </Module>
    );
};
